import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import moment from 'moment';

import api from '~/services/api';
import { isNullOrEmpty } from '~/helpers/util';
import { CatchErrors } from '../common';

import {
  scheduleIndexRequest, scheduleIndexSuccess, scheduleIndexFailure, scheduleCreateSuccess, scheduleCreateFailure,
  scheduleReadSuccess, scheduleReadFailure, scheduleUpdateSuccess, scheduleUpdateFailure, scheduleDeleteSuccess,
  scheduleDeleteFailure
} from './actions';

export function* onIndex({ payload }) {
  try {
    const { filters } = payload;

    let params = '';

    if (Array.isArray(filters)) {
      filters.map(e => {
        if (Object.keys(e).length === 1) {
          params += `${isNullOrEmpty(params) ? "?" : "&"}${Object.keys(e)[0].replace('_', '.')}=${e[Object.keys(e)[0]]}`;
        }
      });
    }

    const response = yield call(api.get, `schedule${params}`);

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;
    if (!result.data) throw 'Verifique sua conexão';

    const data = result.data;

    yield put(scheduleIndexSuccess(data));
  }
  catch (err) {
    CatchErrors(err);
    yield put(scheduleIndexFailure());
  }
}

export function* onCreate({ payload }) {
  try {
    const { name, startAt, endAt, date, finished, current } = payload.data;

    const formData = new FormData();

    formData.append('name', name);
    formData.append('startAt', `${moment(date).format('YYYY-MM-DD')} ${startAt}:00`);
    formData.append('endAt', `${moment(date).format('YYYY-MM-DD')} ${endAt}:00`);
    formData.append('finished', finished ? 1 : 0);

    const response = yield call(api.post, 'schedule', formData);


    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;
    if (!result.data) throw 'Verifique sua conexão';

    const data = result.data;

    yield put(scheduleCreateSuccess(data));
    yield put(scheduleIndexRequest([{ date: moment(current).format('YYYY-MM-DD') }]));

    toast.success(result.message);
  }
  catch (err) {
    CatchErrors(err);
    yield put(scheduleCreateFailure());
  }
}

export function* onRead({ payload }) {
  try {
    const { id } = payload;

    const response = yield call(api.get, `schedule/${id}`);

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;
    if (!result.data) throw 'Verifique sua conexão';

    const data = result.data;

    yield put(scheduleReadSuccess(data));
  }
  catch (err) {
    CatchErrors(err);
    yield put(scheduleReadFailure());
  }
}

export function* onUpdate({ payload }) {
  try {
    const { id, name, startAt, endAt, date, finished, current } = payload.data;

    const formData = new FormData();

    formData.append('name', name);
    formData.append('startAt', `${moment(date).format('YYYY-MM-DD')} ${startAt}:00`);
    formData.append('endAt', `${moment(date).format('YYYY-MM-DD')} ${endAt}:00`);
    formData.append('finished', finished ? 1 : 0);

    const response = yield call(api.post, `schedule/${id}`, formData);

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;
    if (!result.data) throw 'Verifique sua conexão';

    const data = result.data;

    yield put(scheduleUpdateSuccess(data));
    yield put(scheduleIndexRequest([{ date: moment(current).format('YYYY-MM-DD') }]));

    toast.success(result.message);
  }
  catch (err) {
    CatchErrors(err);
    yield put(scheduleUpdateFailure());
  }
}

export function* onDelete({ payload }) {
  try {
    const { id, date } = payload;

    const response = yield call(api.delete, `schedule/${id}`);

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;

    const data = result.data;

    yield put(scheduleDeleteSuccess());
    yield put(scheduleIndexRequest([{ date: moment(date).format('YYYY-MM-DD') }]));

    toast.success(result.message);
  }
  catch (err) {
    CatchErrors(err);
    yield put(scheduleDeleteFailure());
  }
}

export default all([
  takeLatest('@schedule/INDEX_REQUEST', onIndex),
  takeLatest('@schedule/CREATE_REQUEST', onCreate),
  takeLatest('@schedule/READ_REQUEST', onRead),
  takeLatest('@schedule/UPDATE_REQUEST', onUpdate),
  takeLatest('@schedule/DELETE_REQUEST', onDelete),
]);